import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { DispatchProps, OwnProps, StateProps } from './PayrollEditScreen';
import PayrollEdit from './PayrollEditScreen';
import { StoreState } from 'src/store/reducers';
import { getPayroll } from 'src/store/actions/payroll-actions';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        payroll: state.payrolls.current,
        inProgress: state.payrolls.inProgress,
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getData: (id) => dispatch(getPayroll(id)),
    };
}

const PayrollEditScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(PayrollEdit);

export default PayrollEditScreen;
